import { render } from "./ApiDocView.vue?vue&type=template&id=6cabe9f1&scoped=true"
import script from "./ApiDocView.vue?vue&type=script&lang=js"
export * from "./ApiDocView.vue?vue&type=script&lang=js"

import "./ApiDocView.vue?vue&type=style&index=0&id=6cabe9f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cabe9f1"]])

export default __exports__